/**
 * Frontend copy of the Machine ID computation — kept in sync with
 * plugins/team-management-backend/src/utils/machineId.ts.
 *
 * Used for the live Machine ID preview in TeamNameField (FR-006)
 * without requiring a round-trip to the backend.
 */
export function computeMachineId(teamName: string): string {
  let id = teamName
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase()
    .replace(/'/g, '')
    .replace(/[ &,/]/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 63);

  id = id.replace(/^-+|-+$/g, '');

  return id;
}

export function isMachineIdValid(teamName: string): boolean {
  try {
    return computeMachineId(teamName).length >= 2;
  } catch {
    return false;
  }
}
